<script setup lang="ts">
import {Facebook, Instagram, Linkedin, Mail, Phone, Youtube} from 'lucide-vue-next';
import {useLanguage} from '../composables/useLanguage';
import {company} from '../config/company';

const {isArabic, toggleLocale} = useLanguage();
</script>

<template>
  <div class="topbar">
    <div class="container topbar__inner">
      <p>{{ isArabic ? company.taglineAr : company.taglineEn }}</p>
      <div class="topbar__links">
        <a :href="`tel:${company.phone.replaceAll(' ', '')}`"><Phone :size="15" /> <span>{{ company.phone }}</span></a>
        <a :href="`mailto:${company.email}`"><Mail :size="15" /> <span>{{ company.email }}</span></a>
        <span class="socials" aria-label="social media">
          <a href="#" aria-label="Instagram"><Instagram :size="15" /></a>
          <a href="#" aria-label="LinkedIn"><Linkedin :size="15" /></a>
          <a href="#" aria-label="Facebook"><Facebook :size="15" /></a>
          <a href="#" aria-label="YouTube"><Youtube :size="15" /></a>
        </span>
        <button class="language-button" type="button" @click="toggleLocale">{{ isArabic ? 'EN' : 'عربي' }}</button>
      </div>
    </div>
  </div>
</template>
